// src/hooks/useFetchToken.js
import {useState} from 'react';
import axios from 'axios';
import {v4 as uuidv4} from 'uuid';

const useFetchTokenLiveKit = () => {
  const [token, setToken] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const getToken = ({
    teacherName,
    courseName,
    voice_id,
    courseId,
    userId,
    lessonId,
    session_id,
    lastQuestion,
  }) => {
    return new Promise(async (resolve, reject) => {
      setLoading(true);
      try {
        // Determine institution via query param: showLVDemo=true → liberty_village; else quiklearn
        // Institution resolution priority:
        // 1) explicit ?institution=XYZ
        // 2) ?showLVDemo=true → 'liberty_village'
        // 3) default → 'quiklearn'
        let institution = 'quiklearn';
        if (typeof window !== 'undefined') {
          const params = new URLSearchParams(window.location.search);
          const explicitInstitution = params.get('institution');
          const showLVDemo = params.get('showLVDemo');
          if (explicitInstitution && explicitInstitution.trim().length > 0) {
            institution = explicitInstitution.trim();
          } else if (showLVDemo === 'true') {
            institution = 'liberty_village';
          }
        }

        const response = await axios.post(
          'https://livekit-token.quiklearn.ai/get_token',
          {
            instructor: teacherName,
            course: courseName,
            metadata: JSON.stringify({
              voice_id: voice_id,
              institution,
              courseId,
              userId,
              lessonId,
              session_id: session_id,
              last_question: lastQuestion,
            }),
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
        const token = response.data.token; // Adjust according to the response structure
        setToken(token);
        setError(null);
        resolve(token);
      } catch (err) {
        console.error('getToken', err);
        setError(err.message || 'An error occurred');
        setToken(null);
        reject(err);
      } finally {
        setLoading(false);
      }
    });
  };

  return {token, error, loading, getToken};
};

export default useFetchTokenLiveKit;
